import React from 'react';
import classnames from 'classnames';
import ListViewIcon from '@wix/da-shared-react/pkg/Icons/ListView';
import GridViewIcon from '@wix/da-shared-react/pkg/Icons/GridView';
import { SectionViewType } from '../../../types/sections';
import BiButton from '@wix/da-shared-react/pkg/biLogger/Components/BiButton';
import { BiEventType } from '@wix/da-shared-react/pkg/biLogger/constants';

import s from './SectionViewSwitch.scss';

export interface Props {
  className?: string;
  value: SectionViewType;
  onChange: (view: SectionViewType) => void;
}

export class SectionViewTypeSwitch extends React.Component<Props> {
  render() {
    const { className, value } = this.props;
    return (
      <div className={classnames(s['root'], className)}>
        <BiButton
          className={s['icon-btn']}
          onClick={this.setListView}
          biData={{
            evid: BiEventType.PROFILE_GALLERY_VIEW_MODE_CLICK,
            view_mode: 'lists',
          }}
        >
          <ListViewIcon
            className={classnames(
              s['icon'],
              value === SectionViewType.LIST && s['active']
            )}
          />
        </BiButton>
        <BiButton
          className={s['icon-btn']}
          onClick={this.setGridView}
          biData={{
            evid: BiEventType.PROFILE_GALLERY_VIEW_MODE_CLICK,
            view_mode: 'grid',
          }}
        >
          <GridViewIcon
            className={classnames(
              s['icon'],
              value === SectionViewType.GRID && s['active']
            )}
          />
        </BiButton>
      </div>
    );
  }

  setListView = () => {
    this.props.onChange(SectionViewType.LIST);
  };

  setGridView = () => {
    this.props.onChange(SectionViewType.GRID);
  };
}

export default SectionViewTypeSwitch;
